import React from 'react';
import { motion } from 'framer-motion';

const AboutUs = () => {
  return (
    <section id="about" className="scroll-mt-24 bg-lotus-petal/20 px-6 py-20 lg:px-8 lg:py-28">
      <div className="mx-auto max-w-7xl">
        <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-20">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
          >
            <span className="mb-4 block text-xs font-medium uppercase tracking-[0.3em] text-lotus-deep/80">
              About Us
            </span>
            <h2 className="font-serif text-3xl leading-tight text-lotus-ink sm:text-4xl lg:text-5xl">
              Energy & Mental Health Organization
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: 0.2, ease: 'easeOut' }}
            className="space-y-6 text-lg leading-relaxed text-lotus-ink/70"
          >
            <p>
              Lotus Prana is dedicated to individuals and organizations through Pranic Healing, guided meditation, and wellness education. Our work focuses on nurturing the complete well-being of every individual — mentally, emotionally, and energetically.
            </p>
            <p>
              We collaborate with individuals, organizations, educational institutions, and communities to create healthier environments where people can thrive with clarity, resilience, and purpose.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
